import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../../theme';
import { TextInput } from '../TextInput';

export const StyledForm = styled('form')`
    position: relative;
`;

export const StyledTextInput = styled(TextInput)`
    ${({ theme }: { theme: Theme }) => `
        padding-right: ${theme.tggSpacing(rem(9), 22.5)};
	`}
`;

export const StyledContainerForButtons = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: absolute;
        top: ${theme.tggSpacing(0, 0)};
        right: ${theme.tggSpacing(rem(1), 2.5)};
        display: flex;
        align-items: center;
        height: 100%;
	`}
`;

export const StyledClearButton = styled('button')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_14};
    ${({ theme }: { theme: Theme }) => `
        position: absolute;
        right: ${theme.tggSpacing(rem(3.5), 8.75)};
        color: inherit;
        text-decoration: underline;
        cursor: pointer;
        background-color: transparent;
        border: none;
	`}
`;

export const StyledButton = styled('button')`
    ${({ theme }: { theme: Theme }) => `
        position: absolute;
        top: ${theme.tggSpacing(px(4), 1)};
        right: ${theme.tggSpacing(px(3), 0.75)};
        padding: ${theme.tggSpacing(px(5), 1.25)};
        cursor: pointer;
        background: none;
        border: none;

        svg {
            cursor: pointer;
        }
	`}
`;
